import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import apiV2 from "../../services/apiV2";
import toastError from "../../errors/toastError";
import ConfirmationModal from "../ConfirmationModal";

function IconBan() {
	return (
		<svg className="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
			<circle cx="12" cy="12" r="10" />
			<path d="m4.9 4.9 14.2 14.2" />
		</svg>
	);
}

export default function ContactBlockButton({ contact, ticketId, className = "" }) {
	const [blocked, setBlocked] = useState(Boolean(contact?.isBlocked));
	const [loading, setLoading] = useState(false);
	const [confirmOpen, setConfirmOpen] = useState(false);

	useEffect(() => {
		setBlocked(Boolean(contact?.isBlocked));
	}, [contact?.id, contact?.isBlocked]);

	if (!contact?.id || !ticketId || contact.isGroup) return null;

	const contactName = contact.name || "este contato";

	const handleConfirm = async () => {
		const next = !blocked;
		setLoading(true);
		try {
			const { data } = await apiV2.put(`/tickets/${ticketId}/contact-block`, { blocked: next });
			setBlocked(Boolean(data?.isBlocked));
			toast.success(next ? "Contato bloqueado." : "Contato desbloqueado.");
		} catch (err) {
			toastError(err);
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<ConfirmationModal
				title={blocked ? "Desbloquear contato" : "Bloquear contato"}
				open={confirmOpen}
				onClose={() => setConfirmOpen(false)}
				onConfirm={handleConfirm}
			>
				{blocked
					? `Deseja desbloquear ${contactName} no WhatsApp? O contato voltará a poder enviar mensagens.`
					: `Deseja bloquear ${contactName} no WhatsApp? O contato não conseguirá mais enviar mensagens.`}
			</ConfirmationModal>
			<button
				type="button"
				disabled={loading}
				onClick={() => setConfirmOpen(true)}
				className={
					className ||
					(blocked
						? "btn btn-sm mt-2 border border-default-200 bg-transparent text-default-700 hover:border-primary/20 hover:bg-primary/10 hover:text-primary"
						: "btn btn-sm mt-2 border border-red-200 bg-transparent text-red-600 hover:bg-red-50")
				}
			>
				<IconBan />
				{loading ? "Aguarde..." : blocked ? "Desbloquear contato" : "Bloquear contato"}
			</button>
		</>
	);
}
